export const TRAINING_INFO_ROUTE = 'karta-informacyjna';
